import { render, staticRenderFns } from "./exchange-storage.vue?vue&type=template&id=35f5cfb4&scoped=true"
import script from "./exchange-storage.vue?vue&type=script&lang=js"
export * from "./exchange-storage.vue?vue&type=script&lang=js"
import style0 from "./exchange-storage.vue?vue&type=style&index=0&id=35f5cfb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f5cfb4",
  null
  
)

export default component.exports